export default __webpack_public_path__ + "static/media/MagicChime.39eaa156.mp3";